define(['require', 'exports'], function(require, exports) {



    function uiBack(NavigationService) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attr, parentDirectCtrl) {
                $element.bind('click', function() {
                    NavigationService.back();
                })
            }
        }
    }

    function listenBack(NavigationService) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attr, parentDirectCtrl) {
               gadgets.pubsub.unsubscribe("goBack");
               gadgets.pubsub.subscribe("goBack",function(data){
                   NavigationService.back()
               });
            }
        }
    }


    function popupClose(NavigationService) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attr, parentDirectCtrl) {
                $element.bind('click', function() {
                    NavigationService.closePopup(true);
                })
            }
        }
    }

    function uiSubscribe(NavigationService) {
        return {
            restrict: 'A',
            scope: {
                eventName: "@uiSubscribe",
                model: "=?bindTo",
                callback: "=?callback"
            },
            link: function($scope, $element, $attr) {

                NavigationService.subscribe($scope.eventName, function(data) {

                    $scope.$apply(function(){
                    if ($scope.model) {
                        $scope.model = data;
                    } else {
                        $scope.callback(data);
                    }
                });
            });
            }
        }
    }

    function ngModalOverlay(NavigationService){
        return {
            restrict: 'C',
            link: function($scope, $element, $attr) {
                    $element.bind('click', function() {
                            NavigationService.closePopup();
                    })
            }
        }
    }
    function uiPublish(NavigationService) {
        return {
            restrict: 'A',
            scope: {
                eventName: "@uiPublish",
                model: "=?bindTo",
                trigger: "@trigger"
            },
            link: function($scope, $element, $attr) {
                if ($scope.trigger == "click") {
                    $element.bind('click', function() {

                        $scope.$apply(function() {
                            NavigationService.publish($scope.eventName, $scope.model);

                        })
                    })
                }

            }
        }
    }

    function uiPsref(NavigationService) {
        return {
            scope: {
                uiAfter: "=?",
                uiData: "=?"
            },
            restrict: 'A',
            link: function($scope, $element, $attr, parentDirectCtrl) {

                var routeNow = function(json) {

                    NavigationService.go(json)
                }

                $element.click(function() {
                    var state = $attr.uiPsref
                    var json = {
                        'state': state,
                        'link': $attr.uiLink,
                    }

                    if ($scope.uiData) {
                        json.data = $scope.uiData;
                    }
                    if ($attr.uiAfter) {
                        $scope.uiAfter(function(data, newJson) {
                            if (newJson) {
                                json = newJson;
                            }
                            json.data = data;
                            routeNow(json)
                        }, json, $attr)

                    } else {
                        routeNow(json)
                    }
                })
            }
        }

    }


    function modelOutlet($compile, $http, $controller, $templateCache) {
        return {
            restrict: 'E',
            scope: true,
            link: function(scope, element, attrs) {
                var _root = this;
                _root.tpl = null;
                    _root.ctrl = null;
                    _root.html = null;
                    _root.templateCtrl = null;
                    _root.templateScope = null;

                attrs.$observe('tpl', function(val) {
                    _root.tpl = scope.$eval(val);
                    load();
                });

                attrs.$observe('ctrl', function(val) {
                    _root.ctrl = val;
                    load();
                });

                function load() {

                    if (_root.tpl && _root.ctrl && _root.tpl != 'empty' && _root.ctrl != 'empty') {

                        $http.get(_root.tpl, {
                                cache: $templateCache
                            })
                            .then(function(response) {
                                _root.templateScope = scope.$new();
                                _root.templateCtrl = $controller(_root.ctrl, {
                                    $scope: _root.templateScope
                                });
                                element.html(response.data);
                                element.children().data('$ngControllerController', _root.templateCtrl);
                                $compile(element.contents())(_root.templateScope);
                            });
                    }
                }
            }
        };

    }



    function modalContainer($compile, $http, $controller, $templateCache, PlatformService, $timeout,$state) {
        return {
            restrict: 'E',
            scope: true,
            template: '<div modal-dialog="" show="modal">' +
                '<div popup-close="true" nb-intg-events="[0]" class="light-box-close" aria-label="Close"></div>' +
                 '     <div class="anim-in-out mainpopup" ui-view="popup"></div><a href="#" id="preventDefault"></a>'+
                 '</div>',
            controller: function($scope, $rootScope, $state, $window, $stickyState) {
                $scope.modal = false;

                $scope.modalController = "empty";
                $scope.modalTemplate = "empty";



                var popupState;

                $rootScope.$on('popup-close',function(event,data){

                    angular.element('body').removeClass("body-modal-custom");
                    angular.element('header').removeClass("no-z-index");
                    angular.element('.quick-navbar.middle-quick-menus.top-stick-menus .full-width-bg').removeClass("no-z-index");
                    angular.element('.nb-portal .lp-widget-hdfc-nb-profile.profile-section-top').removeClass("no-z-index");
                    angular.element('.lp-admin .navbar-inverse').removeClass("no-z-index");
                    angular.element('.nb-portal footer').removeClass("no-footer-z-index");
                    angular.element('.nb-portal footer > .row').removeClass("no-footer-z-index");
                    angular.element('.sticky-notification-container').removeClass("no-footer-z-index");
                    $scope.modal = false;


                    if(data.value){
                        var dataObj = {"eventCategory":(popupState.title),"eventAction":"closeButtonClick","eventLabel":"close","count":0};
                        gadgets.pubsub.publish("nbGap",dataObj);
                    }
                });

                $rootScope.$on('popup-triger', function(event, requestedState) {
                    console.debug("popup-triger");
                    var stateToShowInPopup=requestedState.name;
                    var widgetName=PlatformService.getWidgetName()

                    if(!/.popup./.test(stateToShowInPopup)){
                     stateToShowInPopup=stateToShowInPopup.replace(widgetName+".",widgetName+".popup.")
                    }
                    $('#preventDefault').on('keydown', function(evt) {
                        if(evt.which == 9){
                            evt.preventDefault();
                        }
                    });
                    console.debug("Requested popup state name ",stateToShowInPopup);
                    popupState=  $state.get(stateToShowInPopup);
                    if(popupState){
                        $stickyState.reset(popupState.name)
                        $state.go( popupState,{},{location:false})
                        angular.element('body').addClass("body-modal-custom");
                        angular.element('header').addClass("no-z-index");
                        angular.element('.quick-navbar.middle-quick-menus.top-stick-menus .full-width-bg').addClass("no-z-index");
                        angular.element('.nb-portal .lp-widget-hdfc-nb-profile.profile-section-top').addClass("no-z-index");
                        angular.element('.lp-admin .navbar-inverse').addClass("no-z-index");                        
                        angular.element('.nb-portal footer').addClass("no-footer-z-index");
                        angular.element('.nb-portal footer > .row').addClass("no-footer-z-index");
                        angular.element('.sticky-notification-container').addClass("no-footer-z-index");
                        angular.element('.ng-modal-overlay').unbind("click");
                    }

                    $timeout(function() {
                        $scope.modal = true;

                    }, 100);
                });

            },
            link: function(scope, element, attrs) {
                var _root = this;
                _root.tpl = null;
                    _root.ctrl = null;

                    attrs.$observe('tpl', function(val) {
                        _root.tpl = scope.$eval(val);
                        scope.modalTemplate = tpl
                    });

                attrs.$observe('ctrl', function(val) {
                    _root.ctrl = val;
                    scope.modalController = val;
                });


            }
        };
    }

    exports.uiPsref = uiPsref;
    exports.modelOutlet = modelOutlet;
    exports.modalContainer = modalContainer;
    exports.uiBack = uiBack;
    exports.uiSubscribe = uiSubscribe;
    exports.uiPublish = uiPublish;
    exports.popupClose=popupClose;
    exports.ngModalOverlay=ngModalOverlay;
    exports.listenBack= listenBack;
   
})


// WEBPACK FOOTER //
// ./src/feature-hdfc-navigation/scripts/directives/directives.js